import React from 'react';
import Swal from "sweetalert2";

//import { useTranslation } from "react-i18next";

import {
    Row, Col
} from "reactstrap";
import CGridstack from 'components/CGridstack';

export default function ItemsContainerFrag(props) {
    const { data, modelFctManager, parentProps, isConfiguration, childShouldRerender, parentDisabled } = props;//bindPropResult

    //const { t } = useTranslation();
    //const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };

    const [shouldRender, setShouldRender] = React.useState(false);

    React.useEffect(() => {
        if (data.onActionEvents && data.onActionEvents["onLoad"]) {
            data.onActionEvents["onLoad"].forEach((args, index) => {
                modelFctManager.onActionRequired(data.name, args, data).then(actionResponse => {
                    //console.debug("RESPONSE");
                    //console.debug(actionResponse);
                    if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: actionResponse.errorMessage
                        });
                    }
                });
            });
        }

        if ((!data.children || data.children.length === 0) && modelFctManager && modelFctManager.finalizeProcess) modelFctManager.finalizeProcess(data, parentProps);
    }, []);

    //useEffect sur props pour trigger APRES le render du composant
    React.useEffect(() => {
        data.childRendered = 0;
        if (childShouldRerender && modelFctManager && modelFctManager.commonRenderProc) modelFctManager.commonRenderProc(data);
    }, [props]);
    if (!childShouldRerender && modelFctManager && modelFctManager.commonRenderProc) modelFctManager.commonRenderProc(data);

    data.functionManager = {};
    data.functionManager.getParentProps = () => { return parentProps; };
    data.functionManager.rerender = (forceChild) => {
        setShouldRender(!shouldRender);
        if (forceChild) {
            data.children.forEach((child) => {
                child?.functionManager?.rerender(true);
            });
        }
    };
    data.functionManager.getParent = () => {
        return parentProps.parentData;
    };
    data.functionManager.triggerChange = () => {
        return new Promise((resolve, reject) => {

            if (data.onActionEvents && data.onActionEvents["onChange"]) {
                data.onActionEvents["onChange"].forEach((args, index) => {
                    modelFctManager.onActionRequired(data.name, args, data).then(actionResponse => {
                        //console.debug("RESPONSE");
                        //console.debug(actionResponse);
                        if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                            Swal.fire({
                                icon: "error",
                                title: "Echec",
                                html: actionResponse.errorMessage
                            });
                        }
                    });
                });
            }

            resolve({ isSuccess: true, result: 0 });
        });
    };

    var childs = [];
    if (data.children) {
        data.children = data.children.filter(child => !child.isCloned);
        childs = data.children.map((child) => {
            var childRender = modelFctManager.componentTyped(child, { parentData: data, childs: data.children, parentDisabled: (parentDisabled || data.disabled ? true : false), stopPartition: (parentProps.stopPartition || data.groupSubName?.startsWith("containerGroup")) });

            if (isConfiguration && !child.gridWidth) {
                var design = child.mergedDesign || child.customDesign?.design;
                var wSize = 0.1;
                if (design) {
                    wSize = design.boxSize || 0/*.1*/;
                }
                child.gridWidth = Math.round(parseFloat(wSize) * 12);
            }
            return childRender;
        });
    }

    modelFctManager.applyChildsClone(data, childs, parentDisabled);

    data.childCount = childs.length;

    var frameClass = "";
    var frameStyle = {};
    var groupClass = "align-items-center";
    var groupStyle = { margin:"0px" };
    if (data.hidden) {
        if (isConfiguration) {
            frameClass += " config-hidden";
        }
        else {
            frameClass += " d-none";
        }
    }
    if (data.checkRights) {
        var hasRights = modelFctManager.checkRights(data.checkRights.entity, data.checkRights.rights);
        if (!hasRights) frameClass += " d-none";
    }

    var design = data.customDesign?.design;
    design = modelFctManager.prepareMergedDesign(data, design, "default_itemsContainer");
    data.mergedDesign = design;
    if (design) {
        if (design.boxSize) {
            frameClass += modelFctManager.manageBoxSize("item-" + parentProps?.parentData?.gridID + "-" + data?.key, design.boxSize, data);
        }

        Object.assign(frameStyle, modelFctManager.setCustomBackground(design, data));
        Object.assign(groupStyle, modelFctManager.managePadding(design, groupClass));
        Object.assign(groupStyle, modelFctManager.manageMargin(design, groupClass));

        if (design.elevation) {
            frameStyle.boxShadow = design.elevation + " " + design.elevation + " 5px rgba(0,0,0,.15)";
        }

        if (design.width) {
            if (parseFloat(design.width.replace("px", "")) >= 0) groupStyle.width = design.width;
            else {
                groupClass += " w-100";
            }
            groupStyle.overflowX = "hidden";//auto
            //frameClass += " m-0";
        }
        if (design.height) {
            if (parseFloat(design.height.replace("px", "")) >= 0) groupStyle.height = design.height;
            else {
                groupClass += " h-100";
            }
            groupStyle.overflowY = "hidden";//auto
            //frameClass += " m-0";
        }

        switch (parseInt(design.spacing)) {
            case 1: groupClass += " gx-1"; break;
            case 2: groupClass += " gx-2"; break;
            case 3: groupClass += " gx-3"; break;
            case 4: groupClass += " gx-4"; break;
            case 5: groupClass += " gx-5"; break;
            default:
                if (design.spacing > 5) groupClass += " gx-5";
                break;
        }
        switch (design.alignment) {//TODO : top/bottom ???
            case "end":
            case "right":
                //frameStyle.direction = "rtl";
                groupClass += " justify-content-end";
                break;
            case "center":
                groupClass += " justify-content-center";
                break;
            default:
                break;
        }
    }

    if (data.subType === "floating") {
        frameClass += " floating-group";
    }

    if (isConfiguration && !data.gridID) data.gridID = Math.floor(Math.random() * 1000000000);

    //return <Col data-name="ItemsContainerFrag" data-element={data.objType} xs="auto" className={`${frameClass} p-0`} style={frameStyle}><Row className={`${groupClass} m-0`} style={groupStyle}>{childs}</Row></Col>;
    return (isConfiguration && !parentProps.stopPartition && data.groupSubName !== "container") ? <div data-name="ItemsContainerFrag" data-element={data.objType} className={`${frameClass} p-0`} style={frameStyle} data-backimage={frameStyle.hasImage || null} data-imageopacity={frameStyle.alpha || null}>
        <CGridstack data={childs.map((child, index) => {
            var width = 1;
            var item;
            if (data.children) {
                item = data.children[index];

                if (item?.objType === "picture") width = 5;

                if (item && item.gridWidth) width = item.gridWidth;
            }
            return { children: child, id: "subitem-" + data.gridID + "-" + (item?.key || index), srcData: item, noCard: true, x: (index > 0 ? width : 0), y: index, w: width/*, h: 1*/, sizeToContent: true };
        })} type={"itemscontainer"} srcData={data} configModel={null} isConfigurationMode={true} withRemove={true} noOneColumn={true} defaultState={true} className="" target={`grid-stack-itemscontainer-${data.gridID}`} gridClass={"grid-stack-nested"} actionsClass={"text-secondary"} gridOpts={{ cellHeight: 50, sizeToContent: true, acceptWidgets: ".grid-item, .grid-itemsContainer, .grid-stack-group .grid-stack-item" }} triggerClick={(grid, dataItem) => { modelFctManager.setSelected(grid, dataItem); }}
            onDropped={(event, prevNode, n) => {
                modelFctManager.dropManager(data, event, prevNode, n);
                setShouldRender(!shouldRender);
            }} />
    </div>
        : <Col data-name="ItemsContainerFrag" onChange={() => { if(data.argumentsObj?.childChange) data.functionManager.triggerChange(); } } data-element={data.objType} xs="auto" className={`${frameClass} p-0`} style={frameStyle} data-backimage={frameStyle.hasImage || null} data-imageopacity={frameStyle.alpha || null}><Row className={`${groupClass}`} style={groupStyle}>{childs}</Row></Col>;
}